import React from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from '../navigation/Navigation';

/**
 * Marketing Layout Component
 * Layout wrapper for marketing website pages
 */
const MarketingLayout: React.FC = () => {
  return (
    <>
      <Navigation />
      <main id="main-content">
        <Outlet />
      </main>
    </>
  );
};

export default MarketingLayout;